
import React from "react";
import { useState, useEffect } from 'react';
//React Router
import { Navigate, useNavigate } from 'react-router-dom'

import dayjs from 'dayjs';

//Utils
import { checkLogin } from '../../../utils/check-login.js'

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";
import { getContratStep, getSpotsList, getIdSpotLoc } from "../../../store/selectors.js"; //global state : contrat state
import { contratStepSlice } from "../../../store/contratStepSlice.js";
import { spotsListSlice } from "../../../store/spotsListSlice.js";

import Button from '@mui/material/Button';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//import created compnenets
import StepOne from './step1/layout/stepone/StepOne' //component for step 1 : location picker, dates and times picker
import StepTwo from './step2/layout/steptwo/StepTwo' //component for step 2 : Shopping Gallery + reminder
import StepThree from './step3/layout/stepthree/StepThree' //component for step 2 : Shopping Gallery + reminder
import StepFour from './step4/layout/stepfour/StepFour' //component for step 2 : Shopping Gallery + reminder
import StepFive from './step5/layout/stepfive/StepFive' //component for step 2 : Shopping Gallery + reminder
import StepSix from './step6/layout/stepsix/StepSix' //component for step 2 : Shopping Gallery + reminder
import StepSeven from './step7/layout/stepseven/StepSeven' //component for step 2 : Shopping Gallery + reminder
import BannerMoutchicLoisirs from "../../../commons/bannerMoutchicLoisirs/BannerMoutchicLoisirs.jsx";
import ManagerNavBar from "../../../components/managernavbar/ManagerNavBar.jsx"; //<ManagerNavBar idSpotLoc={idSpotLoc} />


// Contrat (ex navigator) is the main block, managing navigation step by step
function Contrat() {
    const dispatch = useDispatch();
    const step = useSelector(getContratStep) //global state : contrat step
    const idSpotLoc = useSelector(getIdSpotLoc) //global state : contrat step
    console.log(step)
    const listSpots = useSelector(getSpotsList);

    const navigate = useNavigate();

    useEffect(() => { //change opening hours when spot change (idspot as dependency)

        if (idSpotLoc === 0) { navigate("../manager/"); }

        if (checkLogin() === false) {
            navigate("/manager/login/contrat");
        }; // if no login, no token, go to login page

    }, [])




    const prevStep = (event) => {
        dispatch(contratStepSlice.actions.previousContratStep());
    }
    const nextStep = (event) => {
        dispatch(contratStepSlice.actions.nextContratStep());
    }




    return (
        <main>
            {/* <div >
                <Button variant="contained" onClick={prevStep}>previous step</Button>
                <Button variant="contained" onClick={nextStep}>next step</Button>
            </div> */}



            {/* --------------
                display correct component, based on current shoppinng step :  
                --------------------------*/}

            <BannerMoutchicLoisirs title={"Manager : Outil de réservation de vélos"} />
            <ManagerNavBar idSpotLoc={idSpotLoc} />
            {step === 1 ? <StepOne /> : null}
            {step === 2 ? <StepTwo /> : null}
            {step === 3 ? <StepThree /> : null}
            {step === 4 ? <StepFour /> : null}
            {step === 5 ? <StepFive /> : null}
            {step === 6 ? <StepSix /> : null}
            {step === 7 ? <StepSeven /> : null}

        </main>

    )
}




export default Contrat